
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"32","cy":"32","r":"32","fill":"#FF7900"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M27 39.0868C27 40.2324 28.3009 40.8931 29.2259 40.2173L38.893 33.1546C39.6571 32.5964 39.6588 31.4567 38.8964 30.8962L29.2293 23.7891C28.3047 23.1094 27 23.7695 27 24.9171V39.0868Z","fill":"white"}})])
          )
        }
      }
    